// Company documents — the downloadable standard letters/forms library
// (More → CID Forms). Downloads are logged per agent server-side; documents
// flagged requires_letterhead come back with the global letterhead stamped on.
import client from './client';

/** GET /api/agent/documents — active documents, curated order. */
export const listDocuments = () => client.get('/api/agent/documents');

/** GET /api/agent/documents/:id/download — binary; server logs the download. */
export const downloadDocument = (id) =>
  client.get(`/api/agent/documents/${id}/download`, { responseType: 'blob' });

/** GET /api/agent/documents/:id/prefill-schema — optional fields for the prefill dialog. */
export const getPrefillSchema = (id) => client.get(`/api/agent/documents/${id}/prefill-schema`);

/**
 * POST /api/agent/documents/:id/prefill-html — letterheaded print-ready HTML with
 * values + drawn signatures filled. issueRef=true (the Print/save path) consumes
 * the next running Ref No., logs the download and SAVES the values under that
 * number (the response's issue_id). With issueId — a copy saved earlier — it prints
 * under that copy's existing number instead and updates its saved values; a preview
 * with issueId shows the number. Signatures are never saved.
 */
export const renderPrefill = (id, values, signatures, issueRef = false, issueId = null) =>
  client.post(`/api/agent/documents/${id}/prefill-html`, {
    values, signatures, issue_ref: issueRef, ...(issueId ? { issue_id: issueId } : {}),
  });

/** GET /api/agent/documents/issued — the agent's own printed copies, newest change first. */
export const listIssuedDocuments = (params = {}) => client.get('/api/agent/documents/issued', { params });

/** GET /api/agent/documents/issued/:issueId — one saved copy with the values it was printed with. */
export const getIssuedDocument = (issueId) => client.get(`/api/agent/documents/issued/${issueId}`);
